module.exports = __webpack_public_path__ + "img/medal-white.5b56f096.png";